import React, { Dispatch, SetStateAction } from 'react';
import { IErrorPopup } from './ErrorPopup';

export const GlobalErrorContext = React.createContext<
    [IErrorPopup | undefined, Dispatch<SetStateAction<IErrorPopup | undefined>>]
>([undefined, () => {}]);
